import { CARRIER_LABEL, carrierDe, RateResult } from "../types";

type ResultsCardsProps = {
  results: RateResult[];
};

function getDeliveredTypeLabel(type: string) {
  if (type === "D") return "Domicilio";
  if (type === "S") return "Sucursal";
  return type || "-";
}

function formatPrice(price: number | string) {
  if (typeof price === "number") {
    return `$ ${price.toLocaleString("es-AR")}`;
  }

  return price;
}

export function ResultsCards({ results }: ResultsCardsProps) {
  if (results.length === 0) {
    return (
      <div
        style={{
          border: "1px dashed var(--border)",
          borderRadius: 18,
          padding: 28,
          color: "var(--text-secondary)",
          textAlign: "center",
          background: "var(--surface-alt)",
        }}
      >
        Todavía no hay resultados.
      </div>
    );
  }

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
        gap: 14,
      }}
    >
      {results.map((result, index) => (
        <div
          key={`${result.service}-${result.deliveredType}-${index}`}
          style={{
            border: "1px solid var(--border)",
            borderRadius: 20,
            padding: 18,
            background: "var(--surface-alt)",
            boxShadow: "var(--shadow)",
          }}
        >
          <div
            style={{
              color: "var(--primary)",
              fontSize: 12,
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: 0.4,
            }}
          >
            {CARRIER_LABEL[carrierDe(result)]} · {getDeliveredTypeLabel(result.deliveredType)}
          </div>

          <h3
            style={{
              margin: "6px 0 0",
              color: "var(--text-primary)",
              fontSize: 20,
              fontWeight: 800,
            }}
          >
            {result.service}
          </h3>

          {result.productType && (
            <p
              style={{
                margin: "4px 0 0",
                color: "var(--text-secondary)",
                fontSize: 13,
              }}
            >
              Producto: {result.productType}
            </p>
          )}

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 10,
              marginTop: 16,
            }}
          >
            <Metric label="Precio" value={formatPrice(result.price)} />
            <Metric label="SLA" value={result.sla} />
          </div>
        </div>
      ))}
    </div>
  );
}

function Metric({ label, value }: { label: string; value: string | number }) {
  return (
    <div
      style={{
        border: "1px solid var(--border)",
        borderRadius: 14,
        padding: 12,
        background: "var(--background)",
      }}
    >
      <div
        style={{
          color: "var(--text-secondary)",
          fontSize: 11,
          marginBottom: 4,
        }}
      >
        {label}
      </div>

      <div
        style={{
          color: "var(--text-primary)",
          fontSize: 17,
          fontWeight: 800,
        }}
      >
        {value}
      </div>
    </div>
  );
}